import React from 'react';
import { Microscope, Users, ClipboardCheck, Handshake, Leaf, Award } from 'lucide-react';
import { companyInfo, valuePropositions } from '../data/mockData';

const iconMap = {
  Microscope,
  Users,
  ClipboardCheck,
  Handshake,
  Leaf,
  Award
};

const About = () => {
  return (
    <section id="about" className="py-24" style={{ backgroundColor: 'white' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left: Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 h-64 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://images.pexels.com/photos/1181255/pexels-photo-1181255.jpeg"
                  alt="Equipo profesional"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://images.pexels.com/photos/3758159/pexels-photo-3758159.jpeg"
                  alt="Profesional de limpieza"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://images.pexels.com/photos/7653461/pexels-photo-7653461.jpeg"
                  alt="Espacio corporativo"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Floating Badge */}
            <div 
              className="absolute -bottom-6 -right-6 bg-white rounded-xl p-6 shadow-xl"
            >
              <div 
                className="text-4xl font-bold mb-1"
                style={{ color: '#2E75B6' }}
              >
                2 Años
              </div>
              <div 
                className="text-sm font-semibold"
                style={{ color: '#3B3838' }}
              >
                Transformando Espacios
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h2 
              className="text-4xl font-bold mb-6"
              style={{ color: '#3B3838' }}
            >
              Sobre MERX Consultoria
            </h2>
            
            <p 
              className="text-lg mb-6 leading-relaxed"
              style={{ color: '#6B7280' }}
            >
              Aunque nuestro recorrido es aún corto, estos últimos 2 años han sido 
              maravillosos. Iniciamos nuestro camino el 2 de agosto de 2023, con un 
              objetivo claro: limpiar y transformar espacios.
            </p>

            <div 
              className="p-6 rounded-xl mb-6"
              style={{ backgroundColor: '#E8F2FA' }}
            >
              <h3 
                className="font-bold text-lg mb-2"
                style={{ color: '#2E75B6' }}
              >
                Nuestra Misión
              </h3>
              <p 
                className="text-base leading-relaxed"
                style={{ color: '#3B3838' }}
              >
                {companyInfo.mission}
              </p>
            </div>

            <div 
              className="p-6 rounded-xl"
              style={{ backgroundColor: '#F3E8FA' }}
            >
              <h3 
                className="font-bold text-lg mb-2"
                style={{ color: '#7030A0' }}
              >
                Nuestra Visión
              </h3>
              <p 
                className="text-base leading-relaxed"
                style={{ color: '#3B3838' }}
              >
                {companyInfo.vision}
              </p>
            </div>
          </div>
        </div>

        {/* Value Propositions */}
        <div>
          <h3 
            className="text-3xl font-bold text-center mb-12"
            style={{ color: '#3B3838' }}
          >
            ¿Por Qué Elegir MERX?
          </h3>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {valuePropositions.map((value, index) => {
              const IconComponent = iconMap[value.icon];
              
              return (
                <div 
                  key={index}
                  className="bg-white border-2 border-gray-100 rounded-xl p-6 hover:border-[#2E75B6] hover:shadow-lg transition-all duration-300"
                >
                  <div 
                    className="w-14 h-14 rounded-lg flex items-center justify-center mb-4"
                    style={{ backgroundColor: '#FFF3CD' }}
                  >
                    <IconComponent size={28} style={{ color: '#FFC000' }} />
                  </div>
                  <h4 
                    className="text-lg font-bold mb-2"
                    style={{ color: '#3B3838' }}
                  >
                    {value.title}
                  </h4>
                  <p 
                    className="text-base"
                    style={{ color: '#6B7280' }}
                  >
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
